import { useEffect } from 'react';
import type { ExperienceListItem } from '../../types';
import { BookingTotal } from '../../components/BookingTotal';
import { trackEvent } from '../../utils/track';
import type { BookingFlowState } from '../BookingFlow';

interface Props {
  exp: ExperienceListItem;
  data: BookingFlowState;
  submitting: boolean;
  error: string | null;
  onSubmit: () => void;
}

export function ReviewStep({ exp, data, submitting, error, onSubmit }: Props) {
  const isInstant = exp.bookingType === 'Confirmação Imediata';

  useEffect(() => {
    trackEvent('booking_review_view', {
      experienceCode: exp.experienceCode,
      bookingType: exp.bookingType,
      partySize: data.partySize,
      eventDate: data.date,
      eventTime: data.startsAt,
    });
  }, [exp.experienceCode, exp.bookingType, data.partySize, data.date, data.startsAt]);
  const prettyDate = data.date
    ? new Date(`${data.date}T00:00:00`).toLocaleDateString('pt-BR')
    : '—';
  const prettyTime = data.startsAt
    ? new Date(data.startsAt).toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      })
    : '—';

  return (
    <div className="step">
      <h2 className="step__title">Revisar e {isInstant ? 'pagar' : 'enviar'}</h2>
      <p className="step__lead">
        Confira tudo antes de {isInstant ? 'finalizar o pagamento' : 'enviar ao operador'}.
      </p>

      <div className="review-card">
        <h3 className="review-card__title">{exp.title}</h3>
        <div className="review-card__row"><span>Data</span><strong>{prettyDate}</strong></div>
        <div className="review-card__row"><span>Horário</span><strong>{prettyTime}</strong></div>
        <div className="review-card__row"><span>Pessoas</span><strong>{data.partySize}</strong></div>
        <div className="review-card__row"><span>Em nome de</span><strong>{data.customer.name}</strong></div>
      </div>

      <BookingTotal exp={exp} partySize={data.partySize} />

      {!isInstant && (
        <div className="review-note">
          <strong>Sem cobrança neste momento.</strong> O link de pagamento chega após a confirmação do operador, em até 24h.
        </div>
      )}

      {error && <p className="error">{error}</p>}

      <div className="step__cta-row">
        <button
          type="button"
          className="btn btn--brand btn--lg btn--block"
          onClick={onSubmit}
          disabled={submitting}
        >
          {submitting
            ? 'Enviando…'
            : isInstant
              ? 'Pagar e reservar'
              : 'Enviar solicitação'}
        </button>
      </div>
    </div>
  );
}
